import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import FormDialog from "components/modals/FormDialog";
import {
  invalidateProductsQuery,
  useProductsTable,
} from "hooks/useProductsTable";
import ProductForm from "routes/product/ProductForm";
import ProductService from "services/Product";

export const PRODUCTS_TABLE_CONSTANTS = {
  tableName: "products",
  queryKey: "products",
  className: "Product",
  exportTableName: null,
  header: "Products",
  headerIcon: "shop",
};

const CreateProductModal = withRoleCheck(FormDialog, [
  ACL_RELATIONSHIPS.product.create,
]);

const ProductsTableV3 = () => {
  const { columns, filters } = useProductsTable();

  const fetchProducts = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await ProductService.getTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching products:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={PRODUCTS_TABLE_CONSTANTS.headerIcon}
      header={PRODUCTS_TABLE_CONSTANTS.header}
      queryKey={PRODUCTS_TABLE_CONSTANTS.queryKey}
      className={PRODUCTS_TABLE_CONSTANTS.className}
      tableName={PRODUCTS_TABLE_CONSTANTS.tableName}
      createButton={
        <CreateProductModal
          onSuccess={invalidateProductsQuery}
          modelType="Product"
          FormComponent={ProductForm}
        />
      }
      fetchData={fetchProducts}
      invalidateData={invalidateProductsQuery}
      filters={filters}
      enableSearch
      enableSettings
    />
  );
};

export default ProductsTableV3;
